export default __webpack_public_path__ + "static/media/external_link.8782a62e.svg";